import HeaderDesktop from './HeaderDesktop/HeaderDesktop';
import HeaderMobile from './HeaderMobile/HeaderMobile';
import { isMobile } from 'utils/isMobile';

export default isMobile ? HeaderMobile : HeaderDesktop;
